/** Cycling placeholder examples shown before the user types. */
export const GLOBAL_SEARCH_TYPING_EXAMPLES_EN = [
  'vimshottari dasha',
  'chara karakas',
  'sub lord significator',
  'sambandha transit',
  'lal kitab remedies',
  'bhagyank mulank',
] as const;

export const GLOBAL_SEARCH_TYPING_EXAMPLES_HI = [
  'विंशोत्तरी दशा',
  'चर कारक',
  'उप-स्वामी कारक',
  'सम्बन्ध गोचर',
  'लाल किताब उपाय',
  'भाग्यांक मूलांक',
] as const;
